export enum ScreenSize {
  "1920*1080" = "1920*1080",
  "1200*1920" = "1200*1920",
  "1080*1920" = "1080*1920",
}

export const VertPageMargins = {
  '4%': '4vw',
}

export const HorPageMargins = {
  '2.5%': '2.533vw',
}

//页面边距
export let PageMarginSource = (PageMargins) => Object.keys(PageMargins).map((item) => {
  return { label: item, value: PageMargins[item]};
});

//屏幕尺寸
export let ScreenSizeSource: Array<any> = Object.keys(ScreenSize).map((item) => {
  return { label: item, value: item };
});
